Astro.multiSelect = function () {
    $('select.multi-select').multiSelect();
};
